import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getHouseholdMemberColumn = state => state.householdMemberColumn;

export const getColumnsByName = createSelector(
  getHouseholdMemberColumn,
  fp.get('columnsByName')
);

export const getActiveColumnsByName = createSelector(
  getColumnsByName,
  fp.reduce(
    (all, each) => (each.status === 1 ? fp.set(each.name, each, all) : all),
    {}
  )
);

export const getActiveColumns = createSelector(getActiveColumnsByName, fp.keys);

export const getColumnForName = createSelector(
  (_, name) => name,
  getColumnsByName,
  fp.get
);

export const getIsFetching = createSelector(
  getHouseholdMemberColumn,
  fp.get('fetching')
);

export const getIsFetched = createSelector(
  getHouseholdMemberColumn,
  fp.get('fetched')
);

export const getFetchingError = createSelector(
  getHouseholdMemberColumn,
  fp.get('fetchingError')
);
